exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-activities-design-dropdown .activities-design-toggle.fts-btn.fts-btn-outline:not(.disabled){border:2px dashed var(--fts-gray-300)}.fts-activities-design-dropdown .activities-design-toggle.fts-btn.fts-btn-outline:not(.disabled)>span{font-weight:400}.activities-design-dropdown-menu .dropdown-validate-error{padding:.25rem .75rem .75rem;font-size:.875rem;line-height:1.25rem;color:var(--fts-text)}.activities-design-dropdown-menu .dropdown-validate-error:not(:last-child){margin-bottom:.5rem;border-bottom:1px solid var(--fts-border)}", ""]);

// exports
